import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface GlobalState {
  isBrowsering: boolean;
  browserTime: number;
  camState: number;
  setCamState: (state: number) => void;
  setBrowserTime: (time: number) => void
  setIsBrowser: (flag: boolean) => void
}

export const useGlobalStore = create<GlobalState>()(
  devtools(
    // persist(
    set => ({
      isBrowsering: false,
      camState: 0,
      browserTime: new Date().getTime(),
      setCamState: camState => {
        set(state => ({ camState }));
      },
      setBrowserTime: time => {
        set(state => ({ browserTime: time }));
      },
      setIsBrowser: flag => {
        set(state => ({ isBrowsering: flag }));
      },
    }),
    {
      name: 'global-storage',
    }
    // )
  )
);
